import { render, staticRenderFns } from "./CreateOwnTemplateModal.vue?vue&type=template&id=684d706d"
import script from "./CreateOwnTemplateModal.vue?vue&type=script&lang=js"
export * from "./CreateOwnTemplateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports